import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { asset, checklist, workOrder, inventory } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { QRCode } from "react-qrcode-logo";
import {
  dateToToday,
  formatDateOnly,
  generateAssetQRCodeDataURL,
  generateLocationToArray,
  getStatusColor,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { QrPDF } from "./QrPDF.jsx";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { ImageQr } from "./ImageQr.jsx";

function PrintQRCode() {
  const [datas, setDatas] = useState([]);
  const [openPDF, setOpenPDF] = useState(false);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ company: true });
  const [deleteRow, setDeleteRow] = useState(null);
  const { config } = useAuth();
  const [type, setType] = useState("Asset");
  const navigate = useNavigate();

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      let res;
      if (type == "Asset") {
        res = await asset.list(queryParam);
      }
      if (type == "Part") {
        res = await inventory.list(queryParam);
      }

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  const handleExportPdf = () => {
    setOpenPDF(true);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) =>
        type == "Asset" ? row.asset_name : row.part.part_name,
    },
    {
      name: "QR Code",
      cell: (row) => (
        <div style={{ width: "150px", padding: 10 }}>
          <ImageQr qr={row.barcode} />
        </div>
      ),
    },
  ];

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function handleChangeType(value) {
    setType(value);
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query, type]);

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active"> QR Code</li>
          </ul>

          <h1 className="page-header">QR Code</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  value={type}
                  onChange={(e) => {
                    handleChangeType(e.target.value);
                  }}
                >
                  <option value="">- Type -</option>
                  {["Asset", "Part"].map((c, i) => (
                    <option value={c}>{c}</option>
                  ))}
                </select>
              </div>

              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={handleExportPdf}
                  className="btn btn-outline-theme w-100"
                >
                  Download PDF <i className="bi bi-download"></i>
                </button>

                {openPDF && (
                  <ConfirmationDlg
                    title={`Download ${type} Qr Code`}
                    open={!!openPDF}
                    onClose={() => setOpenPDF(false)}
                    hideCancelBtn
                    btnSubmitText={"Close"}
                    onSubmit={() => setOpenPDF(false)}
                  >
                    <div className="d-flex justify-content-center align-items-center w-100">
                      {datas.length > 0 && (
                        <PDFDownloadLink
                          style={{
                            border: "1px solid #dedede",
                            padding: "5px",
                          }}
                          document={<QrPDF type={type} assets={datas} />}
                          fileName={`${type}-qrcode.pdf`}
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? "Loading document..." : "Download"
                          }
                        </PDFDownloadLink>
                      )}

                      {datas.length == 0 && (
                        <p
                          style={{
                            border: "1px solid #dedede",
                            padding: "5px",
                          }}
                        >
                          Preparing document...
                        </p>
                      )}
                    </div>
                  </ConfirmationDlg>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintQRCode;
